const KEY = 'tt_pinned_v1';

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeAll(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function getPins(uid) {
  const all = readAll();
  return Array.isArray(all[uid]) ? all[uid] : [];
}

export function isPinned(uid, taskId) {
  return getPins(uid).includes(taskId);
}

export function togglePin(uid, taskId) {
  const all = readAll();
  const cur = Array.isArray(all[uid]) ? all[uid] : [];
  const idx = cur.indexOf(taskId);
  if (idx === -1) cur.unshift(taskId);
  else cur.splice(idx, 1);
  all[uid] = cur;
  writeAll(all);
  return cur;
}

export function setPins(uid, ids) {
  const all = readAll();
  all[uid] = ids;
  writeAll(all);
}
